import { render, staticRenderFns } from "./VouchersDetail.vue?vue&type=template&id=2c859ed0&lang=html&"
import script from "./VouchersDetail.vue?vue&type=script&lang=js&"
export * from "./VouchersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports